module.exports = __webpack_public_path__ + "img/work-from-home-dark.ba1b27d0.svg";